import BrowseDeviationSelector from './BrowseDeviationSelector';
export default BrowseDeviationSelector;

//# sourceMappingURL=index.js.map